import React from 'react';
import '../Components/css/Style.css';  
import { FaCheck } from 'react-icons/fa';  


// import image from "../Components/assets/contact.jpg"; 

import image1 from "../Components/assets/13.jpg";
import image2 from "../Components/assets/14.jpg";
import image3 from "../Components/assets/11.jpg";
import image4 from "../Components/assets/16.jpg";



const AboutUs = () => {
    // const values = [
    //     "Excellence In Training And Staffing",
    //     "Innovation In Technologies",
    //     "Integrity In Services",
    //     "Personalized Approach To Individual Needs",
    //     "Collaboration With Candidates And Clients",
    //     "Adaptability In The Fast-Paced World Of IT",
    //     "Client-Centric Focus To Contribute To Their Goals",
    //     "Diversity And Inclusion To Create Inclusivity",
    //     "Community Impact To Make Positive Impact On Broader Community"
    // ];

    const features = [
        "Excellence In Training And Staffing",
        "Innovation In Technologies",
        "Integrity In Services",
        "Collaboration With Candidates And Clients",
        "Adaptability In The Fast-Paced World Of IT",
        "Personalized Approach To Individual Needs",
        "Client-Centric Focus To Contribute To Their Goals",
        "Diversity And Inclusion To Create Inclusivity",
        "Community Impact To Make Positive Impact On Broader Community",
    ];



    return (
        <> 

            <section className="about-us-section"> 
                <div className="about-us-header">
                    <h2>About Us</h2>
                </div>
 
                <div className="about-us-content-wrapper">
                    <div className="about-us-content">
                        <div className="about-us-images-triangle">
                            <div className="top-images-row">
                                <div className="image-box">
                                    <img src={image1} alt="Team Collaboration" />
                                </div>
                                <div className="image-box">
                                    <img src={image2} alt="Training Session" />
                                </div>
                            </div>
                            <div className="bottom-image">
                                <img src={image3} alt="Document Discussion" />
                            </div>
                        </div>

                        <div className="about-us-text">
                            <h5>OUR VISION</h5>
                            <p>
                                Envisioning a future of boundless technological prowess, CareerForge Tech Solutions aims to be the foremost catalyst for individual and organizational success in the IT domain. Our vision is to redefine the landscape of IT training and staffing, fostering a community of highly skilled professionals who drive innovation and shape the digital future.
                            </p>
                            <p>
                                By seamlessly integrating cutting-edge training methodologies with strategic staffing solutions, we aspire to be the trusted enabler that propels both careers and businesses to unparalleled heights.
                            </p>
                        </div>
                    </div>
                </div>

            </section>


 
            <section className="vision-mission">
                <div className="vision-mission-container">
 
                    <div className="text-sections">
                        <div className="text-section"> 
                            <h3 style={{ color: 'yellow' }}>OUR MISSION</h3>
                            <p>
                                At CareerForge Tech Solutions, our mission is to bridge the gap between potential and proficiency in the IT realm. We are dedicated to providing unparalleled training programs that empower individuals with the knowledge and skills essential for success in the dynamic world of technology. Simultaneously, we strive to connect businesses with the right IT talent through our staffing services, ensuring a symbiotic relationship that propels both individuals and organizations toward excellence. Our commitment to innovation, integrity, and personalized solutions forms the cornerstone of our mission.
                            </p>
                        </div>

                        <div className="text-section">
                            <h3 style={{ color: 'yellow' }}>OUR GOALS</h3>
                            <p>
                                Our goal is to become a recognized leader in IT training and staffing by building a robust talent pipeline with a diverse range of skilled IT professionals. Embrace a culture of continuous improvement, staying agile and responsive to industry trends. Establish strategic partnerships with key players in IT Industry, including technology firms, educational institutions, and professional organizations by consistently delivering top-notch staffing solutions that align with their unique needs.
                            </p>
                        </div>
                    </div>

                    <div className="cards-container">
                        <div className="card">
                            <img src={image4} alt="Experience" className="card-img" />
                            <div className="card-overlay"></div>
                            <div className="card-content">
                                <h3>Experience</h3>
                                <p>Certified Technicians with greater industry experience.</p>
                            </div>
                        </div>

                        <div className="card">
                            <img src={image2} alt="Quick Support" className="card-img" />
                            <div className="card-overlay"></div>
                            <div className="card-content">
                                <h3>Quick Support</h3>
                                <p>L1, L2 & L3 level support teams working 24x7.</p>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            {/* Core Values Section */}
            {/* <section className="core-values-section">
                <h2 className="core-values-title">Our Core Values</h2>
                <p className="core-values-description">
                    Our values represent who we are, at our best. Our core values are an active part of everything we do.
                    We focus on doing what’s right while driving amazing outcomes for our client.
                </p>

                <div className="core-values-grid">
                    <div className="core-values-row">
                        {values.slice(0, 4).map((value, index) => (
                            <div key={index} className="core-value-item">
                                <FaCheck className="check-icon" />
                                <span>{value}</span>
                            </div>
                        ))}
                    </div>
 
                    <div className="core-values-row">
                        {values.slice(4, 7).map((value, index) => (
                            <div key={index + 4} className="core-value-item">
                                <FaCheck className="check-icon" />
                                <span>{value}</span>
                            </div>
                        ))}
                    </div>
 
                    <div className="core-values-row">
                        {values.slice(7, 9).map((value, index) => (
                            <div key={index + 7} className="core-value-item">
                                <FaCheck className="check-icon" />
                                <span>{value}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </section> */}

            <section className="core-values">
                <h2>Our Core Values</h2>
                <p>Our values represent who we are, at our best. Our core values are an active part of everything we do. We focus on doing what’s right while driving amazing outcomes for our client</p>
                <div className="feature-container">
                    {features.map((feature, index) => (
                        <div key={index} className="feature-item">
                            <span className="checkmark">&#10004;</span>
                            <span className="feature-text">{feature}</span>
                        </div>
                    ))}
                </div>
            </section>

        </>
    );
};



export default AboutUs;